'use strict';
const getValueForKeyArray = require('@mindmup/js-utils/src/get-value-for-key-array'),
	setValueForKeyArray = require('@mindmup/js-utils/src/set-value-for-key-array'),
	observable = require('@mindmup/mapjs-core/src/util/observable'),
	deepAssign = require('@mindmup/mapjs-core/src/deep-assign');
module.exports = function NodeStyleEditorModel(mapEditorModel, nodeViewModel, themeProvider) {
	let currentAttr = {}, currentNodeLevel = false, currentNodeTheme;
	const dispatcher = observable(this),
		editStyleFor = (attr, nodeLevel) => {
			const nodeTheme = themeProvider.getNodeThemeForLevelAndAttr(nodeLevel, attr),
				effectiveStyles = themeProvider.effectiveStylesForLevelAndAttr(nodeLevel, attr),
				nodeView = nodeViewModel.buildNodeViewForNodeThemeAndAttr(nodeTheme, effectiveStyles, attr, 'text');
			currentAttr = attr;
			currentNodeLevel = nodeLevel;
			currentNodeTheme = nodeTheme;
			dispatcher.dispatchEvent('showNodePreview', nodeView);
		},
		setStyleValue = (style, value) => {
			if (!currentAttr || !currentAttr.style) {
				throw new Error('invalid-args');
			}
			setValueForKeyArray({target: currentAttr.style, keyArray: style.split('.'), value});
			editStyleFor(currentAttr, currentNodeLevel);
		},
		incrementFontMultiplier = increment => {
			if (!currentAttr) {
				throw new Error('invalid-args');
			}
			const currentStyle = currentAttr.style.fontMultiplier || 1,
				current = parseFloat(currentStyle),
				newMultiple = current + increment;
			if (newMultiple < mapEditorModel.FONT_MULTIPLIER_BOUNDS.min || Math.abs(newMultiple - 1) < 0.01) {
				setStyleValue('fontMultiplier', false);
			} else if (!(newMultiple > mapEditorModel.FONT_MULTIPLIER_BOUNDS.max || newMultiple < mapEditorModel.FONT_MULTIPLIER_BOUNDS.min)) {
				setStyleValue('fontMultiplier', newMultiple);
			}
		},
		incrementBorderWidth = increment => {
			const currentStyle = currentAttr?.style?.borderWidth || mapEditorModel.BORDER_WIDTH_BOUNDS.min,
				current = parseFloat(currentStyle),
				newStyle = current + increment;
			if (newStyle >= mapEditorModel.BORDER_WIDTH_BOUNDS.min && newStyle <= mapEditorModel.BORDER_WIDTH_BOUNDS.max) {
				setStyleValue('borderWidth', newStyle);
			}
		},
		incrementCornerRadius = increment => {
			const currentStyle = currentAttr?.style?.cornerRadius || currentNodeTheme.cornerRadius || mapEditorModel.CORNER_RADIUS_BOUNDS.min,
				current = parseFloat(currentStyle),
				newStyle = current + increment;
			if (newStyle >= mapEditorModel.CORNER_RADIUS_BOUNDS.min && newStyle <= mapEditorModel.CORNER_RADIUS_BOUNDS.max) {
				setStyleValue('cornerRadius', newStyle);
			}
		},
		incrementTextMargin = increment => {
			const currentStyle = currentAttr?.style?.margin || currentNodeTheme?.text?.margin || mapEditorModel.TEXT_MARGIN_BOUNDS.min,
				current = parseFloat(currentStyle),
				newStyle = current + increment;
			if (newStyle >= mapEditorModel.TEXT_MARGIN_BOUNDS.min && newStyle <= mapEditorModel.TEXT_MARGIN_BOUNDS.max) {
				setStyleValue('margin', newStyle);
			}
		},

		getThemeValue = (themeStyle) => getValueForKeyArray({target: currentNodeTheme, keyArray: themeStyle.split('.')}),
		showEditor = () => dispatcher.dispatchEvent('showEditor'),
		hideEditor = () => dispatcher.dispatchEvent('hideEditor'),
		saveChanges = () => {
			mapEditorModel.updateNodeStyles(currentAttr.style);
			dispatcher.hideEditor();
		},
		increaseNodeFontMultiplier = () => incrementFontMultiplier(mapEditorModel.FONT_INCREMENT),
		decreaseNodeFontMultiplier = () => incrementFontMultiplier(-1 * mapEditorModel.FONT_INCREMENT),
		resetNodeFontMultiplier = () => setStyleValue('fontMultiplier', false),
		increaseBorderWidth = () => incrementBorderWidth(1),
		decreaseBorderWidth = () =>  incrementBorderWidth(-1),
		resetBorderWidth = () => setStyleValue('borderWidth', false),
		increaseCornerRadius = () => incrementCornerRadius(1),
		decreaseCornerRadius = () =>  incrementCornerRadius(-1),
		resetCornerRadius = () => setStyleValue('cornerRadius', false),
		increaseTextMargin = () => incrementTextMargin(1),
		decreaseTextMargin = () =>  incrementTextMargin(-1),
		resetTextMargin = () => setStyleValue('margin', false);

	Object.freeze(Object.assign(this, {
		getThemeValue, setStyleValue, showEditor, hideEditor, saveChanges,
		increaseNodeFontMultiplier, decreaseNodeFontMultiplier, resetNodeFontMultiplier,
		increaseBorderWidth, decreaseBorderWidth, resetBorderWidth, increaseCornerRadius, decreaseCornerRadius, resetCornerRadius,
		increaseTextMargin, decreaseTextMargin, resetTextMargin

	}));


	mapEditorModel.addEventListener('editNodeStyle', idea => {
		const nodeLevel = themeProvider.getLevelForIdeaId(idea.id),
			oldStyle = idea.attr && idea.attr.style,
			styleClone = oldStyle ? deepAssign({}, idea.attr && idea.attr.style) : {},
			attr = {style: styleClone};
		editStyleFor(attr, nodeLevel);
	});
};
